import { styled } from '@mui/material/styles';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const GatewayRulesFormMappingItemWrapper = styled(CardContent)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});
